import { BrowserModule } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import {  HttpHeaders } from '@angular/common/http';
import {HttpClient} from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EstadoService } from './estado.service';



@Injectable({
  providedIn: 'root'
})
export class DaoService {

  constructor(public confirmationService: ConfirmationService, private estado:EstadoService,private client:HttpClient,private loader: NgxUiLoaderService, public messageService: MessageService) {
    this.servidorLogin = estado.getServidorLogin();
    this.servidorLocalPaulo = estado.getServidorCentral();
    this.servidorBeneficios = estado.getServidorBeneficios();
  }

   getVersao(){
     return '1.0';
   }

   
    
   

  
  registro:any = {};
  servidorLogin: string ="";
  servidorLocalPaulo: string = "";
  servidorBeneficios: string = "";

  contabilizar(acao){
    
    let agora = Date.now();
    let arm = this.registro[acao];
    if(arm){  
      let res = agora-arm;
      this.registro[acao]=agora;
      if(res<120)return true;
      return false;

    }else{
      this.registro[acao]=agora;
      return false;
    }
  }


  submeterLogin(dados:any,acao: string,naoMostrar?:boolean): Promise<any>{
    if(this.contabilizar(acao))return Promise.reject(JSON.stringify("sim"));
    if(!naoMostrar)this.loader.start();
    let headers = new Headers({ 'Content-Type': 'application/json'});
    var headers_object = new HttpHeaders();
    headers_object.append('Content-Type', 'application/json');
    const httpOptions = {headers:headers_object};
    
    if(dados==null){
      dados = {};
    }

    let osdados = JSON.stringify(dados);
   
    
    
   let corpo: any = dados;
 

  
   
    return this.client.post(this.servidorLogin ,corpo,httpOptions).toPromise().then(res=>{
      
      if(!naoMostrar)this.loader.stop();
      let body = res;
      return body || {};
      
      //this.extrairDados
    })
    .catch(er=>{
      if(!naoMostrar)this.loader.stop();
      console.error('An error occurred', er);
      return Promise.reject(er.message || er);
    })//this.lidarComErro);
      
  }

  submeter(dados:any,acao: string,naoMostrar?:boolean,semRejeicao?:boolean): Promise<any>{
    if(!semRejeicao)if(this.contabilizar(acao))return Promise.reject(JSON.stringify("sim"));
    if(!naoMostrar)this.loader.start();
    let headers = new Headers({ 'Content-Type': 'application/json'});
    var headers_object = new HttpHeaders();
    headers_object.append('Content-Type', 'application/json');
    const httpOptions = {headers:headers_object};
    
    if(dados==null){
      dados = {};
    }

    let osdados = JSON.stringify(dados);
 
    
    
   let corpo: any = {"acao":acao,"dados":JSON.stringify(dados)};
 

  
    console.log("Disparando em ", this.servidorLocalPaulo);
    return this.client.post(this.servidorLocalPaulo ,corpo,httpOptions).toPromise().then(res=>{
      
      if(!naoMostrar)this.loader.stop();
      let body = res;
      return body || {};
      
      //this.extrairDados
    })
    .catch(er=>{
      if(!naoMostrar)this.loader.stop();
      console.error('An error occurred', er);
      return Promise.reject(er.message || er);
    })//this.lidarComErro);
      
  }

  submeterBeneficios(dados:any,acao: string,naoMostrar?:boolean): Promise<any>{
    if(this.contabilizar(acao))return Promise.reject(JSON.stringify("sim"));
    if(!naoMostrar)this.loader.start();
    let headers = new Headers({ 'Content-Type': 'application/json'});
    var headers_object = new HttpHeaders();
    headers_object.append('Content-Type', 'application/json');
    const httpOptions = {headers:headers_object};
    
    if(dados==null){
      dados = {};
    }

    let osdados = JSON.stringify(dados);
   
    
    
   let corpo: any = {"acao":acao,"dados":JSON.stringify(dados)};
  

  
   
    return this.client.post(this.servidorBeneficios ,corpo,httpOptions).toPromise().then(res=>{
      
      if(!naoMostrar)this.loader.stop();
      let body = res;
      return body || {};
      
      //this.extrairDados
    })
    .catch(er=>{
      if(!naoMostrar)this.loader.stop();
      console.error('An error occurred', er);
      return Promise.reject(er.message || er);
    })//this.lidarComErro);
      
  }

  extrairDados(res: any){ 
    
 
    
    let body = res;
        return body || {};
  }

  getEnderecoCep(cep): Promise<any> {
    return this.client.get("https://viacep.com.br/ws/" + cep + "/json/").toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);   
  }

  getIBGE(met,dados = ""): Promise<any> {
    let metodo;
    if(met == "estado")
    metodo = "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome";
    else if(met == "cidade")
    metodo = "https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + dados + "/municipios";
    return this.client.get(metodo).toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);   
  }

  getJSON(json){
    return this.client.get("./assets/json/" + json).toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);   
 }  

  retornarTeste(){
    return "positivo";
  }

  toast(cor, texto) { 
    
    if(cor=='s')cor = 'success';
    if(cor=='e')cor = 'error';
    if(cor=='i')cor = 'info';
   
    
    this.messageService.add({key: 'main', severity: cor, summary: '', detail: texto });
  }

  toastS(cor, texto) { //só sai clicando pra sair
    
    if(cor=='s')cor = 'success';
    if(cor=='e')cor = 'error';
    if(cor=='i')cor = 'info';

   
    
    this.messageService.add({key: 'main',  severity: cor, summary: '', detail: texto ,sticky: true});
  }

  dialogConfirm(msg) {
    this.confirmationService.confirm({
        message: msg,
        header: "Atenção!",
        acceptLabel:'Entendido',
        accept: () => {
            //Actual logic to perform a confirmation
        }
    });
}

  lidarComErro(error: any): Promise<any>{
    
    console.error('Ocorreu um erro:', error);
    return Promise.reject(error.message || error);
  }

 



   


  

  

  retornarNomeMes(mes){
    if(mes == 0){
      return "Janeiro";
    }else if(mes == 1){
      return "Fevereiro";
    }else if(mes == 2){
      return "Março";
    }else if(mes == 3){
      return "Abril";
    }else if(mes == 4){
      return "Maio";
    }else if(mes == 5){
      return "Junho";
    }else if(mes == 6){
      return "Julho";
    }else if(mes == 7){
      return "Agosto";
    }else if(mes == 8){
      return "Setembro";
    }else if(mes == 9){
      return "Outubro";
    }else if(mes == 10){
      return "Novembro";
    }else if(mes == 11){
      return "Dezembro";
    }
  }
  
 
  

    
    
    

  
}
